export default __webpack_public_path__ + "static/media/paper-clip.70ce254d.svg";